import React, { useState, useEffect } from 'react';
import 'react-quill/dist/quill.snow.css';
import { ticketCreate } from '../api/ticketApi';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import { ArrowLeft } from 'lucide-react';

const CreateTicket = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    attachments: [],
  });
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState({ type: '', text: '' });
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const categories = [
    { key: 'transaction', value: 'Transaction' },
    { key: 'beneficiary', value: 'Beneficiary' },
    { key: 'others', value: 'others' },
  ];

  useEffect(() => {
    const wsId = sessionStorage.getItem('login_workspaces_id');
    if (wsId) {
      setFormData((prev) => ({
        ...prev,
        workspace: wsId,
      }));
    }
  }, []);

  const handleChange = async (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      const allowedTypes = [
        'image/jpeg',
        'image/png',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'text/csv', // .csv
      ];

      const filesArray = Array.from(files);
      const validFiles = filesArray.filter((file) =>
        allowedTypes.includes(file.type),
      );

      if (validFiles.length !== filesArray.length) {
        setErrors((prev) => ({
          ...prev,
          attachments: 'Only .jpeg, .png, .pdf, .doc, .docx, .xlsx, .csv files are allowed.',
        }));
        return;
      }
      setErrors((prev) => ({
        ...prev,
        attachments: '',
      }));

      const base64Files = await Promise.all(
        filesArray.map(async (file) => {
          const base64 = await convertToBase64(file);

          return {
            name: file.name,
            data: base64,
          };
        }),
      );

      setFormData((prevFormData) => ({
        ...prevFormData,
        attachments: [...(prevFormData.attachments || []), ...base64Files],
      }));
    } else if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else {
      // alert(2);
      const validPattern = /^[a-zA-Z0-9_# ]*$/;

      if (name === 'title' && !validPattern.test(value)) {
        return;
      }

      setFormData({ ...formData, [name]: value });
    }
  };

  const handleDescriptionChange = (value) => {
    const plainText = value.replace(/<[^>]+>/g, '').trim();
    const validPattern = /^[a-zA-Z0-9_# ]*$/;

    if (!validPattern.test(plainText)) {
      setErrors((prev) => ({
        ...prev,
        description:
          'Only letters, numbers, underscores, hashtags, and spaces are allowed.',
      }));
      return;
    }

    setErrors((prev) => ({
      ...prev,
      description: '',
    }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      description: value,
    }));
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  function base64ToBlob(base64Data) {
    const [meta, content] = base64Data.split(',');
    const mime = meta.match(/:(.*?);/)[1];
    const byteChars = atob(content);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  }

  // console.log('formdata', formData);
  const validateForm = () => {
    let formErrors = {};

    if (!formData.title.trim()) {
      formErrors.title = 'Title is required.';
    }

    if (
      !formData.description ||
      formData.description.trim() === '' ||
      formData.description === '<p><br></p>'
    ) {
      formErrors.description = 'Description is required.';
    }

    if (!formData.category) formErrors.category = 'Category is required.';
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg({});
    setErrors({});

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      const form = new FormData();
      form.append('title', formData.title);
      form.append('description', formData.description);
      form.append('category', formData.category);
      form.append('workspace', formData.workspace);

      if (formData.attachments && formData.attachments.length > 0) {
        formData.attachments.forEach((file) => {
          form.append('attachments[]', file.data);
        });
      }
      const res = await ticketCreate(form);
      // console.log('after submit data', res);

      if (res.status === 200 && res.data.message === 'Success') {
        const ticketData = JSON.parse(res.data.tickets);

        console.log(ticketData.attachments);

        // console.log('Created Ticket:', ticketData);
        setResponseMsg({
          type: 'success',
          text: 'Ticket submitted successfully!',
        });

        setFormData({
          title: '',
          description: '',
          category: '',
          workspace: '',
          attachments: [],
        });
        navigate('/contactsupport');
      } else {
        throw new Error('Unexpected response or ticket creation failed ');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || 'Something went wrong!';
      setResponseMsg({ type: 'danger', text: message });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f8fafc] via-[#eff6ff4d] to-[#eef2ff66] flex flex-col items-center pt-10">
      <h1 className="text-[#0B214E] text-xl font-semibold mb-6">
        Create Query
      </h1>

      <div className="w-full max-w-md mb-2">
        <span
          className="flex font-semibold items-center gap-1 text-[#0B214E] text-sm cursor-pointer"
          onClick={() => navigate('/contactsupport')}
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </span>
      </div>

      <div className="w-full max-w-md bg-white rounded-xl shadow-sm border border-[#E6ECF5]">
        <div className="px-5 pt-5 pb-5">
          {responseMsg.type === 'danger' && (
            <p className="text-red-600 text-xs bg-red-100 border border-red-200 rounded px-3 py-2 mb-3">
              {responseMsg.text}
            </p>
          )}

          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="space-y-4">
              {/* Title */}
              <div>
                <label className="block text-xs font-semibold text-[#0B214E] mb-4">
                  Title
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Title"
                  className="w-full border border-[#D6DFEE] rounded-md px-3 py-2 text-sm focus:border-[#0B214E] outline-none"
                />
                {errors.title && (
                  <p className="text-red-500 text-[11px] mt-1">
                    {errors.title}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-xs font-semibold text-[#0B214E] mb-4">
                  Category
                </label>

                <div className="relative ">
                  <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    className={`w-full border border-[#D6DFEE] rounded-md px-3 py-2 text-sm bg-white flex justify-between items-center outline-none ${errors.category
                        ? 'border-red-400'
                        : 'focus:border-[#0B214E]'
                      }`}
                  >
                    <span
                      className={`${!formData.category ? 'text-gray-400' : ''}`}
                    >
                      {formData.category
                        ? categories.find((c) => c.key === formData.category)
                          ?.value
                        : 'Select Category'}
                    </span>

                    <span className="text-gray-500 -mt-4 text-xl">⌄</span>
                  </button>

                  {isOpen && (
                    <div className="absolute w-full mt-2 bg-[#F8FAFC] border border-[#D6DFEE] rounded-md shadow-md z-10">
                      <div className="space-y-0">
                        {categories.map((cat) => (
                          <div
                            key={cat.key}
                            onClick={() => {
                              setFormData({ ...formData, category: cat.key });
                              setIsOpen(false);
                            }}
                            className={`px-3 py-2 text-sm cursor-pointer rounded-md mx-1 ${formData.category === cat.key
                                ? 'bg-[#EEF2F9] text-[#0B214E]'
                                : 'hover:bg-[#F5F7FB]'
                              }`}
                          >
                            {cat.value}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {errors.category && (
                  <p className="text-red-500 text-[11px] mt-1">
                    {errors.category}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-xs font-semibold text-[#0B214E] mb-4">
                  Description
                </label>

                <div className="border border-[#D6DFEE] rounded-md overflow-hidden">
                  <ReactQuill
                    theme="snow"
                    value={formData.description}
                    onChange={handleDescriptionChange}
                    placeholder="Write something..."
                    className="text-sm custom-quill"
                  />

                  <div className="flex items-center gap-2 px-3 py-2 border-t border-[#E6ECF5] text-sm">
                    <input
                      type="file"
                      id="file-upload"
                      name="attachments"
                      accept=".jpeg,.jpg,.png,.pdf,.doc,.docx,.xlsx,.csv"
                      onChange={handleChange}
                      className="hidden"
                      multiple
                    />

                    <label
                      htmlFor="file-upload"
                      className="flex flex-col cursor-pointer"
                    >
                      <span className="flex items-center mb-1 text-[#2563eb] gap-1 text-sm">
                        <img
                          src="./icons/file-attach-icon.svg"
                          alt=""
                          className="w-4 h-4"
                        />
                        Attach File
                      </span>
                      <span className={`text-[10px] leading-tight ${errors.attachments ? 'text-red-500' : 'text-gray-400'}`}>
                        {errors.attachments ? errors.attachments : 'Accepted: .jpeg, .jpg, .png, .pdf, .doc, .docx, .xlsx, .csv'}
                      </span>
                    </label>

                  </div>

                  {formData.attachments?.length > 0 && (
                    <div className="px-3 pb-2 flex flex-wrap gap-2">
                      {formData.attachments.map((file, i) => (
                        <div
                          key={i}
                          className="flex items-center gap-1 border rounded px-2 py-1 text-xs max-w-[130px]"
                        >
                          <a
                            href={URL.createObjectURL(base64ToBlob(file.data))}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="truncate"
                          >
                            Attachment {i + 1}
                          </a>

                          <button
                            type="button"
                            onClick={() => {
                              const updated = formData.attachments.filter(
                                (_, index) => index !== i,
                              );
                              setFormData({
                                ...formData,
                                attachments: updated,
                              });
                            }}
                            className="text-red-500"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {errors.description && (
                  <p className="text-red-500 text-[11px] mt-1">
                    {errors.description}
                  </p>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="w-full max-w-md mt-6">
        <button
          type="submit"
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-[#D4711E] mb-5 text-white py-3.5 text-sm font-semibold rounded-xl hover:bg-[#be6318]"
        >
          {loading ? 'Creating...' : 'Create Query'}
        </button>
      </div>
    </div>
  );
};
export default CreateTicket;
